{
  "info": "מידע",
  "negative": "שגיאה",
  "notice": "אזהרה",
  "positive": "הצלחה"
}
